/** Get one user by ID */
export const userGetSpec = {
    uri: '/user/[user]',
    method: 'GET',
    adminOnly: true,
};
